export const GET_LEADS = '[Leads] Get leads';
export const GET_LEADS_SUCCESS = '[Leads] Get leads Success';
export const GET_LEADS_ERROR = '[Leads] Get leads Error';

export const EXPORT_LEADS = '[Leads] Export';

export const RESET_LEADS = '[Leads] Reset';
